import type { publicOperatorAdmin } from "@kintone-storage/openapi-types";

type GeneratedConnectionKindSummary =
  publicOperatorAdmin.components["schemas"]["ConnectionKindSummary"];
type GeneratedConnectionKindProcedureAvailability =
  publicOperatorAdmin.components["schemas"]["ConnectionKindProcedureAvailability"];
export type StorageRegistrationProcedure =
  publicOperatorAdmin.components["schemas"]["RegistrationProcedure"];
export type StorageConnectionKindId =
  publicOperatorAdmin.components["schemas"]["ConnectionKindId"];
export type StorageConnectionKindCategory =
  GeneratedConnectionKindSummary["connectionKindCategory"];

export interface StorageConnectionKindSummary
  extends Omit<GeneratedConnectionKindSummary, "allowedProcedures"> {
  connectionKindCategory: StorageConnectionKindCategory;
  allowedProcedures: GeneratedConnectionKindProcedureAvailability[];
}

export interface StorageConnectionKindsResponse {
  connectionKinds: StorageConnectionKindSummary[];
}

export interface StorageBrowseWizardState {
  microsoftConnectionMode?: "standard" | "site_search";
  version?: number;
  browseSessionId?: string;
  connectionKindId?: StorageConnectionKindId | "";
  selectedProcedure?: StorageRegistrationProcedure | "";
}

export const STORAGE_BROWSE_WIZARD_STATE_VERSION = 2;

export interface StorageBrowseItemSummary {
  browseItemRef: string;
  displayName: string;
}

export const STORAGE_CONNECTION_KIND_CATEGORY_ORDER: StorageConnectionKindCategory[] = [
  "cloud_file_storage",
  "local_file_server",
  "object_storage",
];

export const STORAGE_CONNECTION_KIND_CATEGORY_LABELS: Record<
  StorageConnectionKindCategory,
  string
> = {
  cloud_file_storage: "クラウドファイルストレージ",
  local_file_server: "ローカル／ファイルサーバー",
  object_storage: "オブジェクトストレージ",
};

export const STORAGE_REGISTRATION_PROCEDURE_LABELS: Record<
  StorageRegistrationProcedure,
  string
> = {
  new_create: "新規作成登録",
  register_existing: "既存リソース登録",
  browse_select_cloud: "参照選択登録",
  browse_select_local: "ローカル参照登録",
  verify_link: "リンク検証登録",
};

export const STORAGE_BROWSE_RESULT_ROUTE = "/console/storages/new/browse-result";
export const STORAGE_BROWSE_WIZARD_STATE_KEY =
  "k-drive-console-storage-browse-wizard";
